import React, { forwardRef, isValidElement } from 'react';
import type { Icon as PhosphorIcon } from '@phosphor-icons/react';

import {
  MPFButton,
  type MPFButtonProps,
} from 'volto-ministerio-publico-federal/components/UI/Buttons';

type MPFIconButtonAccessibleName =
  | { label: string; 'aria-label'?: never }
  | { label?: never; 'aria-label': string };

export type MPFIconButtonProps = Omit<MPFButtonProps, 'children' | 'shape'> & {
  /**
   * Elemento de ícone já instanciado (ex.: `<PrinterIcon />`, `<span>×</span>`)
   * ou o próprio componente de ícone do `@phosphor-icons/react` (ex.: `PrinterIcon`),
   * que é instanciado internamente. O tamanho é herdado do botão via CSS (`& svg`).
   */
  icon: React.ReactElement | PhosphorIcon;
  shape?: 'circle' | 'square';
} & MPFIconButtonAccessibleName;

export const MPFIconButton = forwardRef<
  HTMLButtonElement | HTMLAnchorElement,
  MPFIconButtonProps
>(function MPFIconButton({ icon, label, shape = 'circle', ...rest }, ref) {
  const iconElement = isValidElement(icon)
    ? icon
    : React.createElement(icon as PhosphorIcon);

  return (
    <MPFButton ref={ref} shape={shape} {...rest}>
      <span aria-hidden="true">{iconElement}</span>
      {label && <span className="sr-only">{label}</span>}
    </MPFButton>
  );
});

export default MPFIconButton;
